import 'intersection-observer';
import template from './phase-nav.html';
import './phase-nav.global.css';
import { SCROLL_OFFSET } from '../../../../constants';

class PhaseNavController {
  constructor($timeout, $scope) {
    'ngInject';
    Object.assign(this, {
      $timeout,
      $scope,
      phaseVisibility: {},
    });
  }

  $onInit() {
    // Use the IntersectionObserver API to determine which phase is currently in view,
    // in turn determining which phase is "selected".
    this.observer = new window.IntersectionObserver(
      this.handleIntersectionChange.bind(this),
      {
        rootMargin: `-${SCROLL_OFFSET + 1}px 0px 0px 0px`,
        threshold: [0, 1],
      }
    );

    // Use $timeout to let the whole app render before trying to select the
    // DOM element associated with each phase.
    // Only observe if element is found in case race condition where
    // user may nav away from dashboard before this completes
    this.$timeout(() => {
      this.phases
        .map(phase => document.querySelector(`[tab-id="${phase.id}"]`))
        .forEach(el => el && this.observer.observe(el));
    });
  }

  $onDestroy() {
    this.observer.disconnect();
  }

  get selectedIndex() {
    // Multiple phases can be in view at the same time. We consider the first
    // phase in the listed order that's at least partially in view to be "selected".
    return this.phases
      .findIndex(phase => this.phaseVisibility[phase.id])
      .toString();
  }

  handleIntersectionChange(entries) {
    this.$scope.$apply(() => {
      // Maintain map tracking the visibility of each phase.
      this.phaseVisibility = entries.reduce(
        (phaseVisibility, entry) => {
          return {
            ...phaseVisibility,
            ...{ [entry.target.getAttribute('tab-id')]: entry.isIntersecting },
          };
        },
        { ...this.phaseVisibility }
      );
    });
  }

  click(id, event) {
    event.preventDefault();

    // Broadcast the phase selection, likely causing the y-positions of the anchors
    // in the timeline to shift.
    this.select({ $value: id });

    // Wait for timeline anchors to reposition before attempting to scroll to them.
    this.$timeout(() => {
      const el = document.querySelector(`#${id}`);

      window.scrollBy({
        top: el.getBoundingClientRect().top - SCROLL_OFFSET,
        left: 0,
        behavior: 'smooth',
      });
    }, 100);
  }
}

export const PhaseNavComponent = {
  controller: PhaseNavController,
  bindings: {
    phases: '<',
    moveDate: '<',
    select: '&',
  },
  template,
};
